import { render, staticRenderFns } from "./TaxSettingsList.vue?vue&type=template&id=1b308200&scoped=true&"
import script from "./TaxSettingsList.vue?vue&type=script&lang=js&"
export * from "./TaxSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./TaxSettingsList.vue?vue&type=style&index=0&id=1b308200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b308200",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b308200')) {
      api.createRecord('1b308200', component.options)
    } else {
      api.reload('1b308200', component.options)
    }
    module.hot.accept("./TaxSettingsList.vue?vue&type=template&id=1b308200&scoped=true&", function () {
      api.rerender('1b308200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/TaxSettings/TaxSettingsList.vue"
export default component.exports